<script setup>
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from "@headlessui/vue";

import { useVModel } from "@vueuse/core";

const props = defineProps({
  color: {
    type: String,
    default: "orange",
  },
  options: {
    type: Array,
    required: true,
  },
  modelValue: {
    required: true,
  },
});
const emit = defineEmits(["update:modelValue"]);

const data = useVModel(props, "modelValue", emit);

// @unocss-include
const themes = {
  red: {
    backgroundColor: "bg-red-400",
    unselected: "hover:(bg-red-500 bg-opacity-80)",
    selected: "shadow-sm bg-red-600 ",
  },
  orange: {
    backgroundColor: "bg-orange-400",
    unselected: "hover:(bg-orange-500 bg-opacity-80)",
    selected: "shadow-sm bg-orange-600 ",
  },
  blue: {
    backgroundColor: "bg-blue-400",
    unselected: " hover:(bg-blue-500 bg-opacity-80)",
    selected: "shadow-sm bg-blue-600 ",
  },
};

const theme = computed(() => themes[props.color] || themes.orange);

const selectedTab = ref(props.options.findIndex((option) => option.value === props.modelValue));

function changeTab(index) {
  selectedTab.value = index;
  data.value = props.options[index].value;
}

// hack to get toggle to update after hydration
const key = ref("initial");
onMounted(() => {
  key.value = "mounted";
});
</script>
<template>
  <div :key="key">
    <TabGroup :selectedIndex="selectedTab" @change="changeTab" as="div">
      <TabList class="align-middle select-none ease-in inline-flex gap-1 rounded-4 px-1" :class="theme.backgroundColor">
        <Tab as="template" v-slot="{ selected }" v-for="option in options" :key="option.value">
          <div
            class="block overflow-hidden px-2 min-w-12 text-center py-1 rounded-3 cursor-pointer font-mono text-md shadow-neutral-600 my-1 text-white outline-none"
            :class="{
              [theme.unselected]: !selected,
              [theme.selected]: selected,
            }"
            :title="option?.title"
          >
            {{ option.label }}
          </div>
        </Tab>
      </TabList>
      <TabPanels v-if="options[0]?.description" class="text-stone-500 mt-2">
        <TabPanel v-for="option in options" :key="option.value">
          {{ option.description }}
        </TabPanel>
      </TabPanels>
    </TabGroup>
  </div>
</template>
